/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
import React from 'react'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'

type UnavailabilityAlertProps = {
    open?: boolean
    onClose?: (...args: any[]) => any
    isSystemBlocked?: boolean
    message?: string
}

const UnavailabilityAlert = (props: UnavailabilityAlertProps) => {
    const { open, onClose, isSystemBlocked, message } = props
    const title = isSystemBlocked ? 'Service totalement indisponible' : 'Service partiellement indisponible'

    const onCloseDialog = (event: any, reason: any) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return
        }
        if (onClose) onClose()
    }

    return (
        <Dialog open={!!open} onClose={onCloseDialog} disableEscapeKeyDown={isSystemBlocked}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {message?.split('\n').map((item, index) => (
                    <span key={index}>
                        {item}
                        <br />
                    </span>
                ))}
            </DialogContent>
            <DialogActions>
                {isSystemBlocked === false && (
                    <Button color="secondary" onClick={onClose}>
                        Continuer
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}

const mapStateToProps = ({ mainInfos }: any) => {
    const { isSystemBlocked } = mainInfos
    return {
        isSystemBlocked,
    }
}

export default connect(mapStateToProps, {})(UnavailabilityAlert)
